import React from 'react'

import { HStack } from '~/components/elements/HStack'
import {
  IconButton,
  type IconButtonProps,
} from '~/components/elements/IconButton'
import {
  StyledButton,
  type StyledButtonProps,
} from '~/components/elements/StyledButton'

import { type SavedFilter } from '../../utils'

export type FilterItemProps = {
  filter: SavedFilter
  onDelete: (filterId: string) => void
  onSelect: (filterId: string) => void
}

export const FilterItem = ({ filter, onDelete, onSelect }: FilterItemProps) => {
  const handleDeleteButtonClick = React.useCallback<
    EH<IconButtonProps, 'onClick'>
  >(() => {
    onDelete(filter.id)
  }, [onDelete, filter])

  const handleSelectButtonClick = React.useCallback<
    EH<StyledButtonProps, 'onClick'>
  >(() => {
    onSelect(filter.id)
  }, [onSelect, filter.id])

  return (
    <HStack spacing={0}>
      <IconButton
        buttonStyle="light"
        fillMode="flat"
        icon="delete"
        onClick={handleDeleteButtonClick}
      />

      <StyledButton
        buttonStyle="light"
        fillMode="flat"
        onClick={handleSelectButtonClick}
      >
        {filter.title}
      </StyledButton>
    </HStack>
  )
}
